import { useSidebarGuidedTour } from "src/contexts/global/GuidedTourContext";
import useGuidedTourTrigger from "src/guidedTour/useGuidedTourTrigger";
import useTourForRouteMatch from "src/guidedTour/useTourForRouteMatch";

/**
 * Bundles the guided-tour hooks the sidebar needs (which tour matches the
 * current route, whether it's available, and how to trigger it) into one
 * flat result.
 */
const useSidebarGuidedTourState = () => {
  const { availableInSidebar } = useSidebarGuidedTour();
  const tourName = useTourForRouteMatch();
  const triggerGuidedTour = useGuidedTourTrigger();
  const tourAvailable = tourName ? availableInSidebar?.[tourName] : undefined;

  return { tourName, triggerGuidedTour, tourAvailable };
};

export default useSidebarGuidedTourState;
